'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _trafficManager = require('../traffic-manager.js');

var _trafficManager2 = _interopRequireDefault(_trafficManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var urlRegex = /\[(.+)\]\((https?:\/\/[^\s]+)\)|(https?:\/\/[^\s)]+)|\[(.+)\]\((tel:[\d]+)\)/ig;

/**
 * parseText
 * @returns {React.Object} Returns array of strings and link objects.
 *
 * @param {string} text The input text to be parsed
 * @private
 */
var parseText = function parseText(text) {
  var parts;
  var previousIndex = 0;
  var parsedItems = [];

  if (text.includes('tel:')) {
    var phoneRegex = /tel:([0-9]+)/g;
    var phone = phoneRegex.exec(text)[1];
    _trafficManager2.default.sendEvent('custom', 'cx.help-bot.user.phone.shown', [['phone', phone]]);
  }

  while ((parts = urlRegex.exec(text)) !== null) {
    // eslint-disable-line

    var textPart = text.substr(previousIndex, parts.index - previousIndex);
    if (textPart) {
      parsedItems.push(textPart);
    }

    if (parts[1]) {
      parsedItems.push({ href: parts[2], label: parts[1] });
    } else if (parts[3]) {
      parsedItems.push({ href: parts[3], label: parts[3] });
    } else if (parts[4]) {
      parsedItems.push({ href: parts[5], label: parts[4] });
    }

    previousIndex = urlRegex.lastIndex;
  }

  var remainingText = text.substr(previousIndex);
  if (remainingText) {
    parsedItems.push(remainingText);
  }

  return parsedItems;
};

/**
 * Linkify
 * @returns {React.Element} Replaces any detected links with anchor elements.
 *
 *  Two formats for inline link detection are supported:
 *
 *  1. URL
 *  https://www.godaddy.com/xyz
 *  Group 3 - https://www.godaddy.com/xyz
 *
 *  2. Markdown named link
 *  [Anchor Text](https://www.godaddy.com/xyz)
 *  Group 1 - Anchor Text
 *  Group 2 - https://www.godaddy.com/xyz
 *
 * @param {Object} text The input text to be linkified
 * @public
 */
var Linkify = function Linkify(_ref) {
  var intent = _ref.intent,
      sessionId = _ref.sessionId,
      text = _ref.text;


  var parsedItems = parseText(text || '');

  var handleClick = function handleClick(url) {
    _trafficManager2.default.sendLinkClickEvent('text', intent, sessionId, url);
  };

  return _react2.default.createElement(
    'span',
    null,
    parsedItems.map(function (part, index) {
      return typeof part === 'string' ? _react2.default.createElement(
        'span',
        { key: index },
        part
      ) : _react2.default.createElement(
        'a',
        {
          onClick: function onClick() {
            return handleClick(part.href);
          },
          key: index,
          target: '_blank',
          href: part.href
        },
        part.label
      );
    })
  );
};

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
Linkify.propTypes = {
  intent: _propTypes2.default.object,
  sessionId: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string.isRequired
};

exports.default = Linkify;